export default "dist/images/block-image-box-line.a1b9f9a.png";